<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import CameraVideoPlayer from 'src/components/Camera/CameraPlayer/CameraVideoPlayer.svelte';
	import CameraStatusLabel from 'src/components/Camera/SidepanelLayout/CameraStatusLabel.svelte';
	import CameraCloudStoragePromoBanner from 'src/components/Settings/CameraCloudStorage/CameraCloudStoragePromoBanner.svelte';
	import LastRecordingsV2 from '../../DeviceDrawer/LastRecordingsV2.svelte';
	import RecordingKeyPrompt from 'src/components/Camera/CameraPlayer/RecordingKeyPrompt.svelte';
	import RecordingSetupPrompt from 'src/components/Camera/CameraPlayer/RecordingSetupPrompt.svelte';
	import { ensureDeviceEncryption } from 'src/components/Camera/helpers/recording-key-management';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	// On open: resolve the device key up-front (so recent recordings and thumbnails
	// decrypt without a mid-stream stop), else start the setup flow or password
	// prompt. No-op on firmware without encryption support.
	$: if (device?.id) ensureDeviceEncryption(device);
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center align-items-center"
	>
		<CameraStatusLabel {device} {status} {settings} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div slot="content">
		<CameraVideoPlayer {device} {status} {settings} />
		<LastRecordingsV2 deviceId={device.id} />
		<CameraCloudStoragePromoBanner deviceId={device?.id} />
		<RecordingKeyPrompt />
		<RecordingSetupPrompt {device} />
	</div>
</DeviceViewStateWrapper>
